import invoke from 'lodash/invoke';
import times from 'lodash/times';
import {action, computed, observable, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import messages from './messages';
import {StarClickArea, StarRating, StyledIcon} from './styles';

@injectIntl
@observer
export class StarRatingComponent extends Component {
  static propTypes = {
    numOfRating: PropTypes.number.isRequired,
    onSelect: PropTypes.func
  };

  @observable hoveredRating = 0;
  @observable isHovered = false;
  @observable rating = 0;

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  @computed
  get visibleRating() {
    return this.isHovered ? this.hoveredRating : this.rating;
  }

  @action
  setHoveredRating = rating => {
    this.hoveredRating = rating;
  };

  @action
  setIsHovered = isHovered => {
    this.isHovered = isHovered;
  };

  @action
  setRating = rating => {
    this.rating = rating;
    invoke(this.props, 'onSelect', this.rating);
  };

  handleMouseEnter = () => {
    this.setIsHovered(true);
  };

  handleMouseLeave = () => {
    this.setIsHovered(false);
  };

  render() {
    const {intl, numOfRating} = this.props;
    const {formatMessage} = intl;

    return (
      <StarRating onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        {times(numOfRating).map(index => (
          <StarClickArea
            key={index}
            aria-label={formatMessage(messages.campaign_stars, {
              numberOfStars: index + 1
            })}
            data-cy="star"
            onClick={() => this.setRating(index + 1)}
            onMouseEnter={() => this.setHoveredRating(index + 1)}
            role="button"
          >
            <StyledIcon name={this.visibleRating > index ? 'star' : 'star-border'} size={40} />
          </StarClickArea>
        ))}
      </StarRating>
    );
  }
}

export default StarRatingComponent;
